<h1 mat-dialog-title>
  <fa-icon *ngIf="data.icon" class="faIcon" icon="{{ data.icon }}"></fa-icon>
  <span [class.ml-30]="!data.icon" [innerHTML]="data.title"></span>
  <div mat-button (click)="goOut()" class="btoCLoseModal"><span>×</span></div>
</h1>
<div mat-dialog-content [innerHTML]="data.content"></div>
<div mat-dialog-actions *ngIf="data.footer" [innerHTML]="data.footer"></div>
